import React, { Component, ErrorInfo, ReactNode } from 'react';

import Plug from './Plug';
import withRouter from './withRouter';

interface IProps {
	children: ReactNode;
	router: any;
}

interface IState {
	hasError: boolean;
	originalPathname: null | string;
}

class ErrorBoundary extends Component<IProps, IState> {
	constructor(props: any) {
		super(props);
	}

	public state: IState = {
		hasError: false,
		originalPathname: null,
	};

	public static getDerivedStateFromError(_: Error): IState {
		// Update state so the next render will show the fallback UI.
		return {
			hasError: true,
			originalPathname: null,
		};
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		this.setState({
			hasError: true,
			originalPathname: this.props.router.location.pathname,
		});

		// eslint-disable-next-line no-console
		console.error(error, errorInfo);
	}

	resetError = () => {
		this.setState((state) => ({
			hasError: false,
			originalPathname: state.originalPathname,
		}));
	};

	public render() {

		if (this.state.hasError) {
			const { router } = this.props;

			const pathname = router.location.pathname;

			if (pathname !== this.state.originalPathname) {
				this.resetError();
			}

			return (
				<Plug />
			);
		}

		return this.props.children;
	}
}

export default withRouter(ErrorBoundary);
